export const TOGGLE_THEME = "TOGGLE_THEME";
export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const TOGGLE_UI = "TOGGLE_UI";
export const SET_LABEL = "SET_LABEL";
export const SET_FILTER = "SET_FILTER";
export const SET_EDIT = "SET_EDIT";


